import { styled, Dialog, dialogClasses } from '@mui/material';

export const DialogUpdateCompletedRouteContainer = styled(Dialog)({
  [`& .${dialogClasses.paper}`]: {
    maxWidth: 600,
    width: '100%',
    minHeight: 483,
  },
});

export const DialogUpdateCompletedRouteLoadingContainer = styled('div')({
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  height: '100%',
  flex: 1,
});
